import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import styles from "./styles.m.css";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import { generateImageSources, checkAppSlug } from "../../utils/utils";
import AuthorDetailCard from "../../pages/story/story-templates/shared/author-detail-series-card";

const CollectionSeriesItem = ({
  collection,
  cardWithImageZoom = true,
  hasTruncatedHeadline = true,
  className = "",
  numberOfCardsInViewDesktop,
  authorName = false
}) => {
  const headline = get(collection, ["name"], "");
  const imageCaption = get(collection, ["metadata", "cover-image", "caption"]) || headline;
  const slug = get(collection, ["slug"], "");
  const coverImageS3Key = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], "");
  const coverImageMetaData = get(collection, ["metadata", "cover-image", "cover-image-metadata"], "");

  const Author = get(collection, ["items", 0, "story", "authors"], "");

  if (!(headline && slug)) {
    return null;
  }

  const premiumseriesPagePath = slug => {
    return `/tamil-web-series/${slug}`;
  };

  const checkSlug = checkAppSlug();
  let SourceLink = "";
  if (checkSlug) {
    SourceLink = premiumseriesPagePath(slug);
  }
  return (
    <Link
      className={`${styles["read-more-link"]} ${styles["base"]} `}
      href={premiumseriesPagePath(slug)}
      externalLink={SourceLink}
    >
      <div
        className={`${styles["base-card"]} ${
          numberOfCardsInViewDesktop > 2 ? styles["vertical"] : styles["horizantal"]
        } `}
      >
        <ResponsiveImageWithFallback
          className={styles["image-wrapper"]}
          slug={coverImageS3Key}
          metadata={coverImageMetaData}
          alt={imageCaption}
          imgParams={{ auto: ["format", "compress"] }}
          sources={generateImageSources(
            { aspectRatio: [3, 2], screenWidthCoverage: 0.75 },
            { aspectRatio: [3, 2], screenWidthCoverage: 0.3 }
          )}
        />
        <div className={styles["text-wrapper"]}>
          <div className={styles["bundle-text"]}>
            <h3 className={`${styles["headline"]}`}>
              <span className={styles.highlight}>{collection.name}</span>
            </h3>
          </div>
        </div>
      </div>
      <div className={`${styles["author-section"]}`}>
        <AuthorDetailCard authors={Author} className={styles["author-detail"]} bio={false} authorName={authorName} />
      </div>
    </Link>
  );
};

CollectionSeriesItem.propTypes = {
  cardWithImageZoom: PropTypes.bool,
  hasTruncatedHeadline: PropTypes.bool,
  className: PropTypes.string,
  numberOfCardsInViewDesktop: PropTypes.number,
  authorName: PropTypes.bool,
  collection: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "cover-image-metadata": PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number
      }),
      "cover-image-s3-key": PropTypes.string,
      caption: PropTypes.string
    })
  })
};

export default CollectionSeriesItem;
